// @flow
/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'ログインして入札',
                signup: 'サインアップして入札',
                register_long: 'オークションへの登録',
                pending: '登録保留中',
                declined: '登録拒否',
                closed: 'オークション終了',
                sent: '入札されました',
                outbid: 'あなたより高い入札がありました、{amount}さらに入札しますか?',
                bid: '{amount}の入札',
                winning: 'あなたは勝っている',
            },
            conversions: {
                lot_number: 'ロット{lotNumber}',
            },
            description: {
                estimate_range: '予想金額{low}~{high}',
                images_label: '{currentImageNumber}/{totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: 競合の入札',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    '入札者{paddleNumber}の予約入札が競合の入札者より高い入札を行いました',
                last_bid_retracted: '最後の{amount}の入札は取り消されました',
                liveauctioneers_bid_amount: '{amount}: ライブオークション 入札者 {paddleNumber}',
                liveauctioneers_bid_amount_absentee: '{amount}: ライブオークション 入札者 {paddleNumber}の予約入札',
                lot_number_passed: 'ロット{lotNumber}は通過しました',
                lot_number_reopened: 'ロット{lotNumber}は再オープンしました',
                lot_number_skipped: 'ロット{lotNumber}はスキップされました',
                lot_number_unsold: 'ロット{lotNumber}は落札されていません',
                lot_opened_asking: 'ロット番号{lotNumber}が始まりました - {amount}入札しますか？',
                lot_sold_competing_bidder: 'ロット{lotNumber}は競合入札者に{amount}で落札されました',
                lot_sold_liveauctioneers_bidder: 'ロット{lotNumber}は入札者{paddleNumber}に{amount}で落札されました',
                my_bid_amount: '{amount}: 入札',
                my_bid_amount_absentee: '{amount}: 予約入札',
                my_bid_retracted: 'あなたの{amount}の入札は取り消されました',
                registration_approved: '無事登録されました',
                reserve_not_met: '最低落札価格に未到達',
                you_been_outbid_by_liveauctioneers_absentee: '入札者{paddleNumber}があなたより高い入札を行いました',
                you_ve_won_lot: 'ロット{lotNumber}はあなたに落札されました',
            },
            missives: {
                fair_warning_lot_about_to_close: 'このオークションは間もなく終了します',
                going_once_going_twice: 'さらに入札はしますか？',
                third_and_final_warning: '最後のチャンスです、入札はしますか？',
            },
            status: {
                remaining: '{total}ロット中残り{remaining}ロット',
            },
            thumbnail_scroller: {
                next: '次のロット',
            },
        },
    },
};
